<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-sm-flex" :class="{'d-none': !searching}">
      <b-form @submit.prevent="doSearch">
        <b-input-group class="input-group-merge">
          <b-input-group-prepend is-text>
            <feather-icon
              icon="SearchIcon"
              class="text-muted"
            />
          </b-input-group-prepend>
          <b-form-input
            tabindex="1"
            autofocus
            v-model="searchQuery"
            placeholder="Search by anything..."
          />
          <b-input-group-append>
            <b-button variant="outline-primary" submit @click="doSearch">
              Go
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form>
<!--      <b-button class="ml-1" :to="{name: 'sim-swap-create'}">-->
<!--        Start New Sim Swap-->
<!--      </b-button>-->

    </div>
    <feather-icon
      v-if="!searching"
      class="d-xl-none"
      icon="SearchIcon"
      size="21"
      @click="searching = !searching"
    />

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        v-if="!searching"
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0 d-none d-xl-block">
              Username: {{ user.username }}
            </p>
            <span class="user-status" v-if="!$store.state.app.echoLive">{{ $store.state.app.echoState }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            class="badge-minimal"
            :badge-variant="$store.state.app.echoLive ? 'success' : 'danger'"
          />
        </template>

        <b-dropdown-item link-class="d-flex align-items-center">
          <h4>{{ user.username }}</h4>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MailIcon"
            class="mr-50"
          />
          <span>Inbox</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="CheckSquareIcon"
            class="mr-50"
          />
          <span>Task</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MessageSquareIcon"
            class="mr-50"
          />
          <span>Chat</span>
        </b-dropdown-item>

        <b-dropdown-divider/>

        <b-dropdown-item link-class="d-flex align-items-center" @click="doLogout">
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout now</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import store from '@/store'
import {
  ref, watch, computed, onUnmounted,
} from '@vue/composition-api'
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BForm,
  BInputGroup,
  BInputGroupPrepend,
  BButton, BInputGroupAppend, BFormInput,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import router from "@/router";
import userStoreModule from "@/layouts/components/userStoreModule";
import useJwt from "@/auth/jwt/useJwt";
import axios from '@axios'
import {EventBus} from "@/util/eventbus";

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BForm,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BInputGroupAppend,
    BButton,

    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {
      },
    },
  },
  setup(props, {root}) {
    const USER_STORE_MODULE_NAME = 'user';
    if (!store.hasModule(USER_STORE_MODULE_NAME)) store.registerModule(USER_STORE_MODULE_NAME, userStoreModule);

    onUnmounted(() => {
      if (store.hasModule(USER_STORE_MODULE_NAME)) store.unregisterModule(USER_STORE_MODULE_NAME)
    })

    const doLogout = function () {
      console.log('ok lgout');
      useJwt.logout({}).then(() => {
        window.location.reload(true);
      })
    };

    const toggleVerticalMenuActive = {
      type: Function,
      default: () => {
      },
    };
    const user = ref({});
    const getUser = () => {
      store.dispatch('user/getUser', {
        q: 'test',
        filter: router.currentRoute.params.filter,
        tag: router.currentRoute.params.tag,
        // sortBy: sortBy.value,
      })
        .then(usr => {
          user.value = usr
        })
    };

    getUser();

    const searchQuery = ref('');
    const searching = ref(false);
    const doSearch = function() {
      const txt = encodeURIComponent(searchQuery.value);
      axios.get(`/simple-search?q=${txt}`)
        .then(response => {
          var t = response.data;
          if (t) {
            router.push({name: 'sim-edit', params: {id: t.id}}).catch(err => {});
          } else {
            router.push({name: 'sims', query: {q: txt}}).catch(err => {});
          }
          root.$nextTick(() => searchQuery.value = '');
        })
    }

    const echoStatus = ref(false);
    EventBus.$on('$echo-connected', function(val) {
      console.log('got connection status', val);
      echoStatus.value = val;
    })


    return {
      // toggleVerticalMenuActive,
      user,
      getUser,
      doLogout,
      searchQuery,
      doSearch,
      searching,
      echoStatus
    }
  }
}
</script>
